/** Best-effort favicon for a URL or domain (used for news-source + reference logos).
 * Returns "" when no host can be parsed; callers hide the <img> on error. */
export function faviconFor(urlOrDomain: string | undefined): string {
  const raw = (urlOrDomain ?? "").trim();
  if (!raw) return "";
  let host = raw;
  try {
    host = new URL(raw.startsWith("http") ? raw : `https://${raw}`).hostname;
  } catch {
    host = raw.replace(/^https?:\/\//, "").split("/")[0] ?? raw;
  }
  host = host.replace(/^www\./, "");
  if (!host) return "";
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`;
}

/** Host label for display, e.g. "techcrunch.com". */
export function hostOf(urlOrDomain: string | undefined): string {
  const raw = (urlOrDomain ?? "").trim();
  if (!raw) return "";
  try {
    return new URL(raw.startsWith("http") ? raw : `https://${raw}`).hostname.replace(/^www\./, "");
  } catch {
    return raw.replace(/^https?:\/\//, "").split("/")[0] ?? raw;
  }
}
